import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.XeroAirwallexBatchPaymentStartStep', {
    bubbleText: 'Creation of Airwallex Batch Payment',
    title: 'Requesters will be able to combine Airwallex Batch Payments approved in ApprovalMax into bulk payments and submit them for approval.',
    paymentCreation: 'Payment creation',
    description:
        'Requesters will be able to combine Airwallex Batch Payments approved in ApprovalMax into bulk payments and submit them for approval.',
});
